import { render } from "./Os.vue?vue&type=template&id=34041d55"
import script from "./Os.vue?vue&type=script&lang=js"
export * from "./Os.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__